import { render, staticRenderFns } from "./ReceptionView.vue?vue&type=template&id=12b5cd78&"
import script from "./ReceptionView.vue?vue&type=script&lang=js&"
export * from "./ReceptionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports